import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromFeaturedNews from '../reducers/featured-news.reducer';

export const getFeaturedNewsState = createSelector(fromFeature.getNewsState, (state: fromFeature.NewsState) => state.featuredNews);

export const getFeaturedNewsEntities = createSelector(getFeaturedNewsState, fromFeaturedNews.getFeaturedNewsEntities);

export const getAllFeaturedNews = createSelector(getFeaturedNewsEntities, entities => {
  return Object.keys(entities).map(id => entities[+id]);
});

export const getFeaturedNewsLoading = createSelector(getFeaturedNewsState, fromFeaturedNews.getFeaturedNewsLoading);
export const getFeaturedNewsLoaded = createSelector(getFeaturedNewsState, fromFeaturedNews.getFeaturedNewsLoaded);
export const getFeaturedNewsError = createSelector(getFeaturedNewsState, fromFeaturedNews.getFeaturedNewsError);
